import React, { useState } from 'react';
import { MwobFilter } from '@search';

const styles = {
    container: {
        borderBottom: '1px solid #000',
    },
    button: {
        cursor: 'pointer',
        border: 'none',
        backgroundColor: 'transparent',
        outline: 'none',
    },
    showHideIcon: {
        lineHeight: '1.5rem',
        cursor: 'pointer',
    },
};

const MwobFilters = () => {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className="filter-section" style={styles.container}>
            <button
                className="display7 bold w-100 px-0 py-2"
                style={styles.button}
                onClick={() => setExpanded(!expanded)}
                onKeyDown={() => setExpanded(!expanded)}
                type="button"
            >
                <span className="d-flex justify-content-between text-left" style={{ alignItems: 'start' }}>
                    Other
                    <span style={styles.showHideIcon}>{expanded ? '-' : '+'}</span>
                </span>
            </button>

            <div className="overflow-hidden" style={{ height: expanded ? 'auto' : 0, overflow: 'hidden' }}>
                <div className="ais-RefinementList">
                    <ul className="ais-RefinementList-list">
                        <MwobFilter attribute="minority_owned" label="Minority Owned" />
                        <MwobFilter attribute="woman_owned" label="Woman Owned" />
                    </ul>
                </div>
            </div>
        </div>
    );
};

MwobFilters.propTypes = {
    //
};

export default MwobFilters;
